import { useEffect, useRef } from 'react';
import { useCallingData } from '../components/Context/CallingContext';

const formatTime = (seconds) => {
  const h = String(Math.floor(seconds / 3600)).padStart(2, '0');
  const m = String(Math.floor((seconds % 3600) / 60)).padStart(2, '0');
  const s = String(seconds % 60).padStart(2, '0');
  return `${h}:${m}:${s}`;
};

const Timer = ({ duration, setDuration }) => {
  const { resetTimer } = useCallingData();

  const startTimeRef = useRef(null);
  const intervalRef = useRef(null);

  // 🔹 INIT / RELOAD SAFE
  useEffect(() => {
    const savedStart = localStorage.getItem('callStartTime');

    if (savedStart) {
      startTimeRef.current = Number(savedStart);
    } else {
      const now = Date.now();
      startTimeRef.current = now;
      localStorage.setItem('callStartTime', now.toString());
    }

    intervalRef.current = setInterval(() => {
      const elapsed = Math.floor((Date.now() - startTimeRef.current) / 1000);
      setDuration(elapsed);
    }, 1000);

    return () => clearInterval(intervalRef.current);
  }, [setDuration]);

  // 🔹 RESET (PERFECTLY ATOMIC)
  useEffect(() => {
    if (!resetTimer) return;

    clearInterval(intervalRef.current);

    const now = Date.now();
    startTimeRef.current = now;

    localStorage.setItem('callStartTime', now.toString());
    setDuration(0);

    intervalRef.current = setInterval(() => {
      const elapsed = Math.floor((Date.now() - startTimeRef.current) / 1000);
      setDuration(elapsed);
    }, 1000);
  }, [resetTimer, setDuration]);

  return formatTime(duration);
};

export default Timer;
